import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	enableFinancingServices: false,
	hideMonthlyRates: true,
	useStaticPriceDateRemark: true,
	nextBestActions: [
		{
			icon: 'used-cars',
			description: 'Søg på lager',
			labelText: 'Søg på lager',
			target: '_blank',
			trackingName: 'go to vtp',
			url: 'https://www.audi.dk/dk/web/da/ny-bil/lagerliste.html#filter=carline.{{carlineId}}',
		},
		{
			icon: 'dealer-request',
			description: 'Få din brugte bil vurderet',
			labelText: 'Få din brugte bil vurderet',
			target: '_blank',
			trackingName: 'request a trade-in appraisal',
			url: 'https://ww2.audi.dk/brugtbilsvurdering',
		},
		{
			icon: 'test-drive',
			description: 'Book prøvekørsel',
			labelText: 'Book prøvekørsel',
			target: '_blank',
			trackingName: 'testdrive',
			url: 'https://ww2.audi.dk/book-audi-provetur',
		},
	],
	summaryFooterCta: {
		icon: 'send',
		description: 'Kontakt en forhandler',
		labelText: 'Kontakt en forhandler',
		target: '_blank',

		trackingName: 'contact',
		url: 'https://ww2.audi.dk/book-audi-salgsraadgiver/?audicode={{audiCode}}&confname={{carline}}',
	},
};
